module.exports = __webpack_public_path__ + "img/robot-swiper-img1.a5015c3d.png";